import { fetchPost } from '../Service/ApiService'
import { authmodel } from '../Provider/AuthProvider';

export const approveStarHealth = (selectedIds, resolve, reject) => {
   

    try {
        fetchPost(`starhealth/bulksend`, selectedIds, {
            success: (res) => { resolve(res) },
            fail: (res) => { reject(res) },
            error: (err) => {
                reject({ status: false, message: "Unable to connect server" })
            }
        })
    } catch (e) {
        reject({ status: false, message: "Unable to process operation" })
    }
};

export const rejectStarHealth = (selectedIds, resolve, reject) => {
   

    try {
        fetchPost(`starhealth/bulkreject`, selectedIds, {
            success: (res) => { resolve(res) },
            fail: (res) => { reject(res) },
            error: (err) => {
                reject({ status: false, message: "Unable to connect server" })
            }
        })
    } catch (e) {
        reject({ status: false, message: "Unable to process operation" })
    }
};








